module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Uerkheim-3591b7ce969b9e361b5c3bde0b757caa.svg";